/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_State_PendingInputs */

const en_interview_attendance_state_pending = /** @type {(inputs: Interview_Attendance_State_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not confirmed yet`)
};

const de_interview_attendance_state_pending = /** @type {(inputs: Interview_Attendance_State_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht bestätigt`)
};

/**
* | output |
* | --- |
* | "Not confirmed yet" |
*
* @param {Interview_Attendance_State_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_state_pending = /** @type {((inputs?: Interview_Attendance_State_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_State_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_state_pending(inputs)
	return en_interview_attendance_state_pending(inputs)
});